import {Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer2, AfterViewInit} from '@angular/core';
import {DwModalService, F, UploadFile, UploadXHRArgs} from 'ng-quicksilver';
import { FxDapHttpClient } from 'app/implementation/shared/fx-http-client';
import { DwRoutingMessageService } from '@webdpt/framework';
import { UploadFilter } from 'ng-quicksilver';
import { ParamObj } from '../../programs/a/fxai009/model/data.model';
import { Subject ,Observable } from 'rxjs';
import Viewer from 'viewerjs';
import {FxUserInfoService} from '../../auth/fx-auth/fx-user-info.service';
import {FxFfmpegModalService} from '../fx-ffmpeg-wasm/fx-ffmpeg-modal.service';
import {CdkDragDrop, CdkDragEnter, CdkDropList, DragRef, moveItemInArray} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-img-upload',
  templateUrl: 'img-upload.component.html',
  styles: [
    `
    :host ::ng-deep .customize-footer {
      border-top: 1px solid #e9e9e9;
      padding: 10px 18px 0 10px;
      text-align: right;
      border-radius: 0 0 0px 0px;
      margin: 15px -16px -5px -16px;
    }
    i.anticon.anticon-star {
      z-index: 10;
      transition: all .3s;
      cursor: pointer;
      font-size: 16px;
      width: 16px;
      color: rgba(255, 255, 255, 0.85);
  }
  .stick-wrapper{
      border: 1px dashed #d9d9d9;
      width: 104px !important;
      height: 104px !important;
      min-width: 104px !important;
      min-height: 104px !important;
      max-width: 104px !important;
      max-height: 104px !important;
      border-radius: 4px;
      background-color: #fafafa;
      margin-right: 8px;
      margin-bottom: 8px;
      align-items: center;
      display: flex;

    }
    .stick-wrapper:after{
      content: '请粘贴图片上传';
      padding: 12px;
      text-align: center;
    }

      .img-upload-title {
        position: absolute;
        margin-top: 80px;
        padding-left: 5px;
        background: #2672ca;
        width: 102px;
        color: white;
        text-overflow: revert;
        white-space: nowrap;
        font-size: 12px;
        line-height: 22px;
      }
      .img-upload-title-rtl {
        position: absolute;
        margin-top: 80px;
        padding-left: 5px;
        background: #2672ca;
        width: 102px;
        color: white;
        white-space: nowrap;
        font-size: 12px;
        line-height: 22px;
        padding-right: 5px;
        direction: rtl;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: right;
      }

      ul#img-upload-view {
        column-gap: 8px;
        row-gap: 8px;
      }

      span.img-upload-actions {
        width: 102px;
        height: 102px;
        margin: 0;
        padding: 38px 10px 36px 10px;
      }

      .img-view-info {
        width: 102px;
        height: 102px;
      }

      .img-view-info:before {
        width: 102px;
        height: 102px;
      }

      .example-custom-placeholder {
        background: #ccc;
        border: dotted 3px #999;
        width: 102px;
        height: 102px;
        transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
      }
    `
  ]
})
export class ImgUploadComponent implements OnInit, AfterViewInit  {
  //style="display: none;"
  // <i nz-icon nzType="youtube" nzTheme="outline"></i>
  // <img [src]="../../assets/home/v_player.png" *ngIf="imgitem.fileType == 'mp4'|| imgitem.fileType == 'ogg' || imgitem.fileType == 'webm'" >

  metaData: any;

  //@ViewChild('myCanvas') myCanvas: any;
  //@ViewChild('photo') photo: any;
  @Output() open: EventEmitter<any> = new EventEmitter();

  _imgList = [];
  // previewImage = '';
  previewVisible = false;
  _disabled = false;
  _isgetData = true;
  _showButton = true;
  _showStickButton = false;// 是否显示粘贴上传按钮
  showUploadList = {
    showPreviewIcon: true,
    showRemoveIcon: true,
    showDefaultIcon: false
  };
  ischecked = true;
  nowImgitem = '';
  // nowImgitem ='http://fx.digiwin.com:8880/group1/M00/00/17/rBBlB15wm9yAKOBHABsepY_1WwM036.mp4?filename=wx_camera_15711487196232.mp4&ts=1584438237&token=57aed7ad22af9bb23cdad7e47ba19522'; //点击视频信息
  public beforeUpload;
  public imagesView;
  @Input() limit: number = 0; //限制上传图片个数
  public _picFileOption: any;
  @Input() set picFileOption(_picFileOption: any) {
    this._picFileOption = _picFileOption;
  }
  //是否自动获取数据库数据
  @Input() set isgetData(value: boolean) {
    this._isgetData = value;
  }
  // 图片列表
  @Input() set imgList(value: any) {
    this.imgListChange.emit(value);
    this._imgList = value;
  }
  @Output() imgListChange = new EventEmitter();

  @Input() set disabled(disabled: boolean) { //禁用图片编辑
    this._disabled = disabled;
  }
  // 是否显示上传按钮
  @Input() set showButton(value: boolean) {
    this._showButton = value;
    this.showUploadList.showRemoveIcon = this._showButton;
  }
  // 是否显示粘贴上传按钮
  @Input() set showStickButton(value: boolean) {
    this._showStickButton = value;
  }
  @Input() disDefault = false;

  @ViewChild('videoPriview') videoPriview: ElementRef; // 视频预览的页面标签属性 doc

  @Input() autoCompress: boolean = false;
  // 不修改 dw-upload-btn-component 的情况下，不好传递参数。因此暂不考虑在使用处修改参数
  @Input() sizeLimit: number = 300 * 1024;
  @Input() private compressStyle: string = 'scale|0.5|quality|0.8';
  @Input() private supportCompressFileType: string = 'image/jpeg,image/png,image/webp,image/bmp,image/tiff';

  public stickTextShow: boolean = true; // 显示粘贴上传的tips
  constructor(
    public http: FxDapHttpClient,
    public _elementRef: ElementRef,
    public fxUserService: FxUserInfoService,
    public dwMessage: DwRoutingMessageService,
    public dwModalService: DwModalService,
    public fxFfmpegModalService: FxFfmpegModalService
    ) {
    }

  ngOnInit(): void {
    this.showUploadList.showDefaultIcon = this.disDefault;
    if (this._isgetData) {
      this.getImgListdata();
    }
    setTimeout(() => {
      if (this.limit > 0 ) {
        this._disabled = this._imgList.length == this.limit &&this.limit !== 0 ? true : false;
      }
    }, 1000);
    // 使用 sessionStorage 传递变量
    sessionStorage.setItem('app-img-upload.autoCompress', '' + this.autoCompress);
    sessionStorage.setItem('app-img-upload.sizeLimit', '' + this.sizeLimit);
    sessionStorage.setItem('app-img-upload.compressStyle',  '' + this.compressStyle);
  }

  getImgListdata(): void {
    if (this._picFileOption.aay001 && this._picFileOption.aay002 && this._picFileOption.aay003) {
      this.http.post('A/IACommonService/pub_get_aay', { param: this._picFileOption}).subscribe(
        response => {
          if (response.success && response.data) {
            const arrNo = response.data.map(item => (('number' === typeof item.aay011) ? item.aay011 : -1));
            let maxNo = Math.max(...arrNo);
            maxNo = maxNo > -1 ? maxNo : 0;
            this._imgList = response.data
              .map(item => {
                const aay011 = ('number' === typeof item.aay011) ? item.aay011 : ++maxNo;
                return  {
                ...item, aay011: aay011, number: aay011
                };
              }).sort((a, b) => a.aay011 - a.aay011);
            this.imgList = this._imgList.filter(item => item.aay010 === '1');
          }
        });
    } else {
      this._imgList = [];
      this.imgList = this._imgList;
    }
  }

  public handlePreview = (file: UploadFile) => {
    // console.log('图片预览')
    // this.previewImage = file.url || file.thumbUrl;
    // this.filetype = file.type;
    // this.previewVisible = true;
    if (!file.fileType) {
      return;
    }
    var index = this._imgList.findIndex(function (obj) {
      return obj.uid == file.uid;
    });
    var imgIndex = 0; //图片展示下标
    if (file.fileType == 'svg' || file.fileType == 'mp4'|| file.fileType == 'ogg' || file.fileType == 'webm' || file.fileType == 'MOV') {
      let needReload = false;
      this.previewVisible = true;
      if (this.nowImgitem != file.url) {
        needReload = true;
      }
      this.nowImgitem = file.url;

      if (needReload) {
        (this.videoPriview.nativeElement as HTMLVideoElement).load(); // 视频doc重新加载 保证属性刷新
      }

      // let player = document.getElementsByClassName('img-upload-video');
      // player.src = "新的地址" ''
      // player.play()
    } else {
      var filterData = this._imgList.filter(function (obj) {
        return  obj.fileType != 'mp4' && obj.fileType != 'ogg' && obj.fileType != 'webm' && obj.fileType != 'MOV' && obj.url !='assets/img/home/v_player.png';
      });
      imgIndex = filterData.findIndex(function (obj) {
        return obj.uid == file.uid;
      });
      // if (this.imagesView) {
      //   this.imagesView.update();
      //   // this.imagesView.show();
      //   this.imagesView.view(imgIndex);
      // } else {
        var eleName = this._picFileOption.aay003 ?'img-view'+ this._picFileOption.aay003 : 'img-view';
        this.imagesView = new Viewer(document.getElementsByClassName(eleName)[0]
        , {
          // backdrop: false,
          filter(image) {
            // console.log('图片信息', image, image.src.split('?')[0].substring(image.src.split('?')[0].lastIndexOf(".") + 1).toLowerCase());
            var type = image.src.split('?')[0].substring(image.src.split('?')[0].lastIndexOf('.') + 1).toLowerCase();
            return  type != 'mp4' && type != 'ogg' && type != 'webm' && type != 'MOV' && !image.src.endsWith('assets/img/home/v_player.png');
          },
          hidden() {
            console.log('hidden');
            this.viewer.destroy();
          }
        });
        this.imagesView.view(imgIndex);
      // }
    }
  };

  public handleRemove(file): boolean{
    const flag = true;
    var index = this._imgList.findIndex(function (obj) {
      return obj.uid == file.uid;
    });
    this._imgList.splice(index,1);
    this.imgList = this._imgList.map(function (obj) {
      return Object.assign({response: [], thumbUrl: ''}, obj);
    });
    setTimeout(() => {
      if (this.limit > 0 ) {
        this._disabled = this._imgList.length == this.limit &&this.limit !== 0 ? true : false;
      }
    }, 1000);
    return flag;
  }

  public handleDefault(file): boolean{
    if (!this._showButton) {
      return;
    }
    var checkstatus = file.ischecked === 'Y' ? 'N' : 'Y';
    for (var idx = 0; idx < this._imgList.length; idx++) {
      this._imgList[idx].ischecked = 'N';
      this._imgList[idx].aay009 = 'N';
    }
    file.status = 'ischecking';
    file.ischecked = checkstatus;
    file.aay009 = file.ischecked;
    this.imgList = this._imgList.map(function (obj) {
      return Object.assign({response: [], thumbUrl: ''}, obj);
    });
    // this.changeImg(file);
    return true;
  }



  //上传图片
  customReqImg = (item: UploadXHRArgs) => {
    if (item.file.type.startsWith('video/') && this.fxFfmpegModalService.getSystemConfNeedAutoCompress()) {
      return this.uploadVideo(item);
    }

    // 构建一个 FormData 对象，用于存储文件或其他参数
    const formData = new FormData();
    formData.append('attach', item.file as any);
    // 从 sessionStorage 中读取配置
    const _autoCompress = sessionStorage.getItem('app-img-upload.autoCompress') === 'true';
    const _sizeLimit = Number.parseInt(sessionStorage.getItem('app-img-upload.sizeLimit'), 10);
    const _compressStyle = sessionStorage.getItem('app-img-upload.compressStyle') || 'scale|0.5|quality|0.8';
      // 从 sessionStorage 中读取配置
    let resquestUrl = 'A/IAttachFileService/uploadFile';
    if (_autoCompress && this.supportCompressFileType.indexOf(item.file.type) > -1  && item.file.size > _sizeLimit ) {
      resquestUrl = 'A/IAttachFileService/uploadImage';
      if (_compressStyle) {
        formData.append('style', this.compressStyle);
      }
    }

    this.http.post(resquestUrl, formData).subscribe(response => {
      if (response.successValue) {
        item.onSuccess!(response.data, item.file!, '');
      } else {
        this.dwMessage.errorNew(response.message, response.isRemind, response.programNo, response.programName);
      }
      console.log(this._imgList.length);
    });
  }

  uploadVideoFileTypeFilter = (file: UploadFile): boolean => {
    // 上传视频文件前自动压缩
    const needAutoCompress =  this.fxFfmpegModalService.getSystemConfNeedAutoCompress();
    // 如果启用了视频自动压缩，原文件需要是 ffmpeg 支持解码的文件
    // 否则，只允许选择 mp4 文件
    // 检查是否是支持转换的视频格式
    if (needAutoCompress) {
      return this.fxFfmpegModalService.checkFileTypeSupport(file.type);
    } else {
      return file.type === 'video/mp4';
    }
  }

  uploadVideoFileSizeFilter = (file: UploadFile, cs015_byte: number): boolean => {
    // 上传视频文件前自动压缩
    const needAutoCompress =  this.fxFfmpegModalService.getSystemConfNeedAutoCompress();
    // 视频自动压缩方案
    // const planName =  this.fxFfmpegModalService.getSystemConfCompressPlan();
    // 如果启用了视频自动压缩，允许选择 cs_015 10 倍大小以内的文件
    // 否则，允许选择文件大小低于 cs_015 的文件
    const maxFileSize: number = needAutoCompress ? (cs015_byte * 10) : cs015_byte;
    return file.size <= maxFileSize;
  }

  uploadVideo = (item: UploadXHRArgs): void => {
    this.fxFfmpegModalService.openModal(item.file).subscribe(data => {
      if (data) {
        item.onSuccess!(data, item.file!, '');
      }
    });
  }

  //上传图片
  customReqImgAI = (item: UploadXHRArgs) => {
    console.log('[item]',item);
    // 构建一个 FormData 对象，用于存储文件或其他参数
    const formData = new FormData();
    formData.append('attach', item.file as any);
    this.http.post('AI/IBaiduAIService/uploadFile', formData).subscribe(response => {
      if (response.successValue) {
        console.log('response',response);
        console.log('img_list',this._imgList);
        item.onSuccess!(response.data, item.file!, '');
        if(Array.isArray(response.data)&&response.data.length>0){
           if(response.data[0].hasMeta){

            console.log('meta',response.data[0].meta);

            this.metaData=response.data[0].meta;
            //this.onCreateCanvas(item.file);
            this.open.emit(this.metaData);

           }
        }

      } else {
        this.dwMessage.errorNew(response.message, response.isRemind, response.programNo, response.programName);
      }
      console.log(this._imgList.length);
    });
  };


  /*
  onCreateCanvas(file): boolean{
    console.log('AI');
    const flag = true;
    var index = this._imgList.findIndex(function (obj) {
      return obj.uid == file.uid;
    });
  // console.log(img1.naturalWidth, img1.naturalHeight) 可获取图片的原始宽度和高度
  //1706 × 1279
  let canvasWidth = 1279 ;// 这里设置固定值
  let canvasHeight = 1706 ;
  let canvas = this.myCanvas.nativeElement;

  let context = canvas.getContext('2d');


  canvas.width = canvasWidth; // canvas画布宽度
  canvas.height = canvasHeight ;// canvas画布高度
  context.fillStyle = '#ffffff';
  context.fillRect(0, 0, canvas.width, canvas.height);//给canvas设置背景白色

  context.fillStyle = 'black' // 设置文字的填充颜色
  context.font = '15px Georgia' // 设置文字的填充样式


  if(Array.isArray(this.metaData.words_result)){

    var num:number = this.metaData.words_result.length;
    var i:number;

    for (i=0 ; i< num;i++ ) {


        if(this.metaData.words_result[i].words!=null&&this.metaData.words_result[i].location!=null){

          context.fillText(this.metaData.words_result[i].words.toString(), this.metaData.words_result[i].location.top, this.metaData.words_result[i].location.left) // 在画布中添加文字

        }

    }
  }



  //context.fillText(this.metaData.toString(), 100, 440) // 在画布中添加文字

  //context.fillStyle = 'black' // 设置文字的填充颜色
  //context.font = '15px Georgia' // 设置文字的填充样式
  //context.fillText(this.metaData, 245, 500) // 在画布中添加文字

  let newImg = new Image()
  newImg.src = canvas.toDataURL('image/png') // canvas画布导出图片

this.photo.nativeElement.append(newImg) // 将图片插入div中展示出来

return flag;
}

*/
  //格式化图片信息
  changeImg(file): void{
    if(file.type == 'success'){
      file.file.status = 'done';
      for(var i= 0;i< file.fileList.length;i++){
        if(file.fileList[i].uid == file.file.uid){
          file.fileList[i].id = file.file.response[0].id;
          file.fileList[i].url = file.file.response[0].url;
          file.fileList[i].fileSize = file.file.response[0].fileSize;
          file.fileList[i].fileType = file.file.response[0].fileType;
          file.fileList[i].name = file.file.response[0].fileName;
          file.fileList[i].uploadDate = file.file.response[0].uploadDate;
          file.fileList[i].status = 'done';
          file.fileList[i].aay009 = file.file.ischecked;
          file.fileList[i].aaystus = 'N';
          file.fileList[i].aay010 = '1';
        }
      }
    } else if (file.type == 'ischecking') {
      for(var i= 0;i< file.fileList.length;i++){
        file.fileList[i].aay009 = file.fileList[i].ischecked;
      }
    }
    console.log('==图片变化', this._imgList, file);
    // this._imgList = file.fileList;
    this.imgList = this._imgList.map(function (obj) {
      return Object.assign({response: [], thumbUrl: ''}, obj);
    });
    setTimeout(() => {
      if (this.limit > 0 ) {
        this._disabled = this._imgList.length == this.limit &&this.limit !== 0 ? true : false;
      }
    }, 1000);
  }
  filters: UploadFilter[] = [
    {
      name: 'type',
      fn: (fileList: UploadFile[]) => {
        const filterFiles = fileList.filter(w => {
          if (w.type.startsWith('video/')) {
            return this.uploadVideoFileTypeFilter(w);
          } else {
            return ['image/png', 'image/jpeg', 'image/gif', 'image/bmp', 'image/svg+xml'].includes(w.type);
          }
        });
        if (filterFiles.length !== fileList.length) {
          this.dwMessage.error(`包含文件格式不正确，只支持 png/jpg/jpeg/gif/bmp/mp4 格式`);
          return filterFiles;
        }
        return fileList;
      }
    },
    {
      name: 'size',
      fn: (fileList: UploadFile[]) => {
        const c_S015: string= this.fxUserService.getSysParamById('c_S015');
        let c_S015_M:number= Number(c_S015);
        let c_S015_Byte:number= 0;
        //若配置数值不的0~500范围之内或带单位
        if(c_S015_M>=0&&c_S015_M<=500){
          c_S015_Byte=c_S015_M*1024*1024;
        }else{
          //默认100M
          c_S015_M=100;
          c_S015_Byte=104857600;
        }
        const filterFiles = fileList.filter(w => {
          if (w.type.startsWith('video/')) {
            return this.uploadVideoFileSizeFilter(w, c_S015_Byte);
          } else {
            return Number(w.size) <= c_S015_Byte;
          }
        }); // 1M=1024kb
        if (filterFiles.length !== fileList.length) {
          this.dwMessage.error('图片或文件上传大小，单个照片或文件不能超过'+c_S015+'M！');
          return filterFiles;
        }
        return fileList;
      }
    }
    // , //异步验证器
    // {
    //   name: 'async',
    //   fn: (fileList: UploadFile[]) => {
    //     return new Observable((observer: Observer<UploadFile[]>) => {
    //       // doing
    //       observer.next(fileList);
    //       observer.complete();
    //     });
    //   }
    // }
  ];
  public getImgList(): any {
    this._imgList.forEach(element => {
      element.response = [];
      element.thumbUrl = '';
    });
    this.imgList = this._imgList.map(function (obj) {
      return Object.assign({response: [], thumbUrl: ''}, obj, {});
    });
    // return this._imgList;
    return this._imgList.map((img, index) => ({
      ...img,
      aay011: '' + index,
      number: '' + index,
    }));
  }

  // 粘贴图片事件
  pasteData(event) {
    if (event && event.clipboardData) {
      var clipboardData = event.clipboardData.items;
      this.stickTextShow = clipboardData.length ? false : true;
     for (var i = 0; i < clipboardData.length; i++) {
        if (clipboardData[i].kind === 'file') {
          var blob = clipboardData[i].getAsFile();
          if (blob.size === 0) {
            return;
          }
         this.customReqStickImg(blob);
        }
      }
    }
  }

  //上传粘贴图片
  customReqStickImg = (item: UploadXHRArgs) => {
    // 构建一个 FormData 对象，用于存储文件或其他参数
    const formData = new FormData();
    formData.append('attach', item as any);
    this.http.post('A/IAttachFileService/uploadFile', formData).subscribe(response => {
      if (response.successValue) {
        this._imgList.push(response.data[0]);
        this.imgList = this._imgList.map(function (obj) {
          return Object.assign({response: [], thumbUrl: ''}, obj);
        });
        const stickList = this._elementRef.nativeElement.querySelectorAll((this._picFileOption && this._picFileOption.aay003) ? ('#stick-view' + (this._picFileOption.aay003)) : '#stick-view');
        stickList.forEach(s => {
          s.innerHTML = '';
        });
        this.stickTextShow = true;
      } else {
        this.dwMessage.errorNew(response.message, response.isRemind, response.programNo, response.programName);
      }
    });
  };

  /** cdk drag control start **/
  @ViewChild(CdkDropList) placeholder: CdkDropList;
  private target: CdkDropList = null;
  private targetIndex: number;
  private source: CdkDropList = null;
  private sourceIndex: number;
  private dragRef: DragRef = null;

  ngAfterViewInit(): void {
    if (!this.placeholder) {
      return;
    }
    const placeholderElement = this.placeholder.element.nativeElement;
    placeholderElement.style.display = 'none';
    placeholderElement.parentNode.removeChild(placeholderElement);
  }

  public dropListDropped2 = (event: CdkDragDrop<string[]>) => {
    console.log('dropListDropped', event);

    // if (this.sourceIndex !== this.targetIndex) {
    moveItemInArray(this._imgList, event.previousIndex, event.currentIndex);
    // }
  }

  public dropListDropped = (event: CdkDragDrop<string[]>) => {
    console.log('dropListDropped', event);

    if (!this.target) {
      return;
    }

    const placeholderElement: HTMLElement =
      this.placeholder.element.nativeElement;
    const placeholderParentElement: HTMLElement =
      placeholderElement.parentElement;

    placeholderElement.style.display = 'none';

    placeholderParentElement.removeChild(placeholderElement);
    placeholderParentElement.appendChild(placeholderElement);
    placeholderParentElement.insertBefore(
      this.source.element.nativeElement,
      placeholderParentElement.children[this.sourceIndex]
    );

    if (this.placeholder._dropListRef.isDragging()) {
      this.placeholder._dropListRef.exit(this.dragRef);
    }

    this.target = null;
    this.source = null;
    this.dragRef = null;

    if (this.sourceIndex !== this.targetIndex) {
      moveItemInArray(this._imgList, this.sourceIndex, this.targetIndex);
      this._reSortArray(this._imgList, this.sourceIndex, this.targetIndex);
    }
  }

  private _reSortArray = (lst: Array<any>, sourceIndex: number, targetIndex: number): void => {
    let maxNo = 0;
    // 对顺序变化了的区间重新赋值 aay011 和 number
    // dropListEntered 也会修改排序，导致在区间外数组变化。这里的暂解是对完整数组重新排序
    for (let i = 0; i <= lst.length; i++) {
      lst[i]['aay011'] = maxNo;
      lst[i]['number'] = maxNo;
      ++maxNo;
    }
  }

  public dropListEntered = ({item, container}: CdkDragEnter) => {
    console.log('dropListEntered', event);

    if (container == this.placeholder) {
      return;
    }

    const placeholderElement: HTMLElement =
      this.placeholder.element.nativeElement;
    const sourceElement: HTMLElement = item.dropContainer.element.nativeElement;
    const dropElement: HTMLElement = container.element.nativeElement;
    const dragIndex: number = Array.prototype.indexOf.call(
      dropElement.parentElement.children,
      this.source ? placeholderElement : sourceElement
    );
    const dropIndex: number = Array.prototype.indexOf.call(
      dropElement.parentElement.children,
      dropElement
    );

    if (!this.source) {
      this.sourceIndex = dragIndex;
      this.source = item.dropContainer;

      placeholderElement.style.width = '102px';
      placeholderElement.style.height = '102px';

      sourceElement.parentElement.removeChild(sourceElement);
    }

    this.targetIndex = dropIndex;
    this.target = container;
    this.dragRef = item._dragRef;

    placeholderElement.style.display = '';

    dropElement.parentElement.insertBefore(
      placeholderElement,
      dropIndex > dragIndex ? dropElement.nextSibling : dropElement
    );

    this.placeholder._dropListRef.enter(
      item._dragRef,
      item.element.nativeElement.offsetLeft,
      item.element.nativeElement.offsetTop
    );
  }

  public cdkDropListExited = (event: CdkDragDrop<string[]>) => {
    console.log('cdkDropListExited', event);
  }

  public cdkDropListSorted = (event: CdkDragDrop<string[]>) => {
    console.log('cdkDropListSorted', event);
  }

  /** cdk drag control end **/

}
